export default __webpack_public_path__ + "static/media/HalfCircle2.847d2612.svg";